// Copyright (c) 2017 Deere & Company

import CreateClaimModal from '../../../shared/state/create-claim-modal';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

const updateCreateClaimModalVisibility = (state, action) =>
    CreateClaimModal.update(state, {
        $merge: {
            isModalOpen: action.isOpen,
            selectedPin: action.pin
        }
    });

const resetCreateClaimModal = () => getDefaultState().createClaimModal;

export default (state = getDefaultState().createClaimModal, action) => {

    const actionTypes = {
        [actions.RESET_CLAIMS_IN_PROGRESS]: resetCreateClaimModal,
        [actions.UPDATE_CLAIMS_IN_PROGRESS_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_CLAIMS_IN_PROGRESS_CREATE_CLAIM_MODAL_VISIBILITY]: updateCreateClaimModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/reducers/create-claim.js